import { GLOBAL_LAYOUT_KEY, SLOT_KEY, listDirection } from './embed/common';

import jobRoutes from './embed/job';
import siteRoutes from './embed/site';
import customerRoutes from './embed/customer';
import quoteRoutes from './embed/quote';
import assetRoutes from './embed/asset';
import invoiceRoutes from './embed/invoice';
import libraryRoutes from './embed/library';
import visitRoutes from './embed/visit';
import stockRoutes from './embed/stock';
import subContractorRoutes from './embed/sub-contractor';
import purchaseOrderRoutes from './embed/purchase-order';
import globalRoutes from './embed/global';
import partRoutes from './embed/part';
import settingsRoutes from './embed/settings';
import ppmRoutes from './embed/ppm';
import supplierReturnedNotes from './embed/supplier-returned-notes';
import systemSetup from './embed/system-setup';
import locationRoutes from './embed/location';
import templateRoutes from './embed/template';
import staffRoutes from './embed/staff';
import projectRoutes from './embed/project';
import grnRoutes from './embed/goods-received-notes';
import portalRoutes from './embed/portal';
import syncHistoryRoutes from './embed/sync-history';
import electronicFormRoutes from './embed/electronic-form';
import creditRoutes from './embed/credit';
import contractPurchaseOrderRoutes from './embed/contract-purchase-order';
import scheduleOfRate from './embed/schedule-of-rate';
import scheduler from './embed/scheduler';
import jobTemplateRoutes from './embed/job-template';
import quoteTemplateRoutes from './embed/quote-template';
import purchaseOrderTemplateRoutes from './embed/purchase-order-template';
import equipmentRoutes from './embed/equipment';
import hireAssetsRoutes from './embed/hire-assets';

// Portal Routes
import portalCustomerRoutes from './embed/portal/customer';
import portalGlobalRoutes from './embed/portal/global'
import portalSiteDetailRoutes from './embed/portal/site';
import portalJobRoutes from './embed/portal/job';
import assembledPartRoutes from './embed/assembled-part';
const LIST_PAGE_BAU = [
  ...globalRoutes,
  ...jobRoutes,
  ...siteRoutes,
  ...customerRoutes,
  ...quoteRoutes,
  ...assetRoutes,
  ...invoiceRoutes,
  ...libraryRoutes,
  ...visitRoutes,
  ...stockRoutes,
  ...subContractorRoutes,
  ...purchaseOrderRoutes,
  ...partRoutes,
  ...ppmRoutes,
  ...settingsRoutes,
  ...supplierReturnedNotes,
  ...systemSetup,
  ...locationRoutes,
  ...templateRoutes,
  ...staffRoutes,
  ...projectRoutes,
  ...grnRoutes,
  ...portalRoutes,
  ...syncHistoryRoutes,
  ...electronicFormRoutes,
  ...creditRoutes,
  ...contractPurchaseOrderRoutes,
  ...scheduleOfRate,
  ...scheduler,
  ...jobTemplateRoutes,
  ...quoteTemplateRoutes,
  ...purchaseOrderTemplateRoutes,
  ...equipmentRoutes,
  ...hireAssetsRoutes,
  ...assembledPartRoutes
];

const LIST_PAGE_CUSTOMER_PORTAL = [
  ...portalGlobalRoutes,
  ...portalCustomerRoutes,
  ...portalSiteDetailRoutes,
  ...portalJobRoutes
]

export {
  GLOBAL_LAYOUT_KEY,
  SLOT_KEY,

  listDirection,
  LIST_PAGE_BAU,
  LIST_PAGE_CUSTOMER_PORTAL
}



